module.exports = __webpack_public_path__ + "img/img-6.9100b25e.png";